import { Modal } from "@circle-react-uikit/ModalV2";
import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import { NewSpaceGroupForm } from "@circle-react/components/SpaceGroups/NewFormV2";
import { useCreateSpaceGroupMutation } from "@circle-react/components/SpaceGroups/NewFormV2/hooks/useCreateSpaceGroupMutation";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

import type { NewSpaceGroupModalProps } from "./types";

const formId = "new-space-group-form";

export const NewSpaceGroupModalUIKitComponent = ({
  position,
  prefillData,
}: NewSpaceGroupModalProps) => {
  const modal = useModal();

  const { mutate: createSpaceGroupMutation, isPending: isSubmitting } =
    useCreateSpaceGroupMutation({
      position,
      onSuccess: () => {
        void modal.hide();
      },
    });

  return (
    <Modal
      title={t("space_groups.form.create.title")}
      isOpen={modal.visible}
      onClose={modal.hide}
    >
      <Modal.Overlay />
      <Modal.Content size="md">
        <Modal.Header className="!px-6 md:!px-8">
          <Modal.Title size="md">
            {t("space_groups.form.create.title")}
          </Modal.Title>
          <Modal.HeaderActions>
            <Modal.CloseButton onClick={modal.hide} />
          </Modal.HeaderActions>
        </Modal.Header>
        <Modal.Body className="!px-6 md:!px-8">
          <NewSpaceGroupForm
            formId={formId}
            onSubmit={createSpaceGroupMutation}
            prefillData={prefillData}
          />
        </Modal.Body>
        <Modal.Footer className="flex justify-end">
          <Button
            type="submit"
            variant="circle"
            form={formId}
            disabled={isSubmitting}
            full
            large
          >
            {isSubmitting
              ? t("space_groups.form.create.submitting")
              : t("space_groups.form.create.submit")}
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
};
